import { useMutation } from "@tanstack/react-query"
import { updateLearningGroupFetch } from "store/middlewares/affiliation.crud"

const useUpdateLearningGroup = () => {

    const { mutateAsync: updateLearningGroup } = useMutation({
        mutationFn: updateLearningGroupFetch
    })

    return updateLearningGroup
}

export default useUpdateLearningGroup